import { useMemo } from 'react';
import { useAuthState } from 'state';
import { AccountInfo } from 'types';
import ApiService from './ApiService';

export class VendorService extends ApiService {
    async getVendor(vendorId: string): Promise<AccountInfo | null> {
        const { data, status } = await this.get(`/api/vendors/${vendorId}`);
        return this.IsSuccessStatusCode(status) ? data : null;
    }

    async getVendorList() : Promise<AccountInfo[]>{
        const { data, status } = await this.get(`/api/vendors/current`);
        return this.IsSuccessStatusCode(status) ? data : [];
    }
}

export const useVendorService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new VendorService(), [auth]);
};